export enum LocaleConstants {
    NL = 0,
    EN = 1,
}

export enum LocaleStrings {
    NL = 'nl',
    EN = 'en',
}

export const getLocaleFromLocaleString = (localeString: LocaleStrings) => {
    switch (localeString) {
        case LocaleStrings.EN:
            return LocaleConstants.EN
        case LocaleStrings.NL:
        default:
            return LocaleConstants.NL
    }
}

export const getLocaleStringFromLocale = (locale: LocaleConstants) => {
    switch (locale) {
        case LocaleConstants.EN:
            return LocaleStrings.EN
        case LocaleConstants.NL:
        default:
            return LocaleStrings.NL
    }
}
